/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type VerifyGitlabServerIntegrationInput = {
    url: string;
    token: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type verifyGitlabServerIntegrationMutationVariables = {
    input: VerifyGitlabServerIntegrationInput;
};
export type verifyGitlabServerIntegrationMutationResponse = {
    readonly verifyGitlabServerIntegration: {
        readonly success: boolean | null;
        readonly message: string | null;
        readonly company: {
            readonly id: string;
            readonly gitlabServerEnabled: boolean | null;
        } | null;
    } | null;
};
export type verifyGitlabServerIntegrationMutation = {
    readonly response: verifyGitlabServerIntegrationMutationResponse;
    readonly variables: verifyGitlabServerIntegrationMutationVariables;
};



/*
mutation verifyGitlabServerIntegrationMutation(
  $input: VerifyGitlabServerIntegrationInput!
) {
  verifyGitlabServerIntegration(input: $input) {
    success
    message
    company {
      id
      gitlabServerEnabled
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "VerifyGitlabServerIntegrationInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "VerifyGitlabServerIntegrationPayload",
    "kind": "LinkedField",
    "name": "verifyGitlabServerIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gitlabServerEnabled",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "verifyGitlabServerIntegrationMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "verifyGitlabServerIntegrationMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "verifyGitlabServerIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation verifyGitlabServerIntegrationMutation(\n  $input: VerifyGitlabServerIntegrationInput!\n) {\n  verifyGitlabServerIntegration(input: $input) {\n    success\n    message\n    company {\n      id\n      gitlabServerEnabled\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '90cc2f47a14f02cdfacea1a75b3a8664';
export default node;
